module.exports = __webpack_public_path__ + "static/media/BY.d62cda59.jpg";